<template>
  <div>
    <!-- <div class="text-center">
        <a href="javascript:;" data-toggle="modal" data-target="#static-backdrop-modal-preview-add-volunteer" class="btn btn-primary">Show Modal</a>
    </div> -->
    <div
      id="static-backdrop-modal-preview-add-volunteer"
      class="modal grid justify-center content-center"
      data-backdrop="static"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content bg-theme-25 px-2">
          <div class="modal-header">
            <h4 class="font-medium text-base mr-auto font-bold">
              อพม.
            </h4>
          </div>
          <div class="modal-body grid grid-cols-12 gap-x-4 gap-y-3">
            <div
              class="md:col-span-12 xs:col-span-12"
              :class="{
                error: v$.idcardStaff.$errors.length || sumId === false,
              }"
            >
              <label class="form-label text-theme-98">
                เลขบัตรประจำตัวประชาชน <span class="text-theme-5">*</span>
              </label>
              <input
                id="idcard-staff-input"
                type="text"
                class="form-control placeholder-theme-19"
                v-model="state.idcardStaff"
                placeholder="กรุณากรอกเลขบัตรประจำตัวประชาชน"
                data-test="idcard-staff-input"
                @input="onlyNumber"
                maxlength="13"
              />
              <div v-if="sumId === false" class="error-msg">
                กรุณากรอกเลขบัตรประชาชนให้ถูกต้อง
              </div>
              <div
                v-else
                class="input-errors"
                v-for="error of v$.idcardStaff.$errors"
                :key="error.$uid"
              >
                <div class="error-msg">{{ error.$message }}</div>
              </div>
            </div>
            <div class="md:col-span-3 xs:col-span-12">
              <label class="form-label text-theme-98">
                คำนำหน้าชื่อ <span class="text-theme-5">*</span>
              </label>
              <treeselect
                id="dropdown-staff"
                v-model="state.titleStaffSelected"
                noResultsText="ไม่พบข้อมูล"
                :options="title"
                placeholder="กรุณาเลือกคำนำหน้า"
                data-test="dropdown-staff"
                :clearable="false"
                :class="{ errorselect: v$.titleStaffSelected.$errors.length }"
              />
              <div
                class="input-errors"
                v-for="error of v$.titleStaffSelected.$errors"
                :key="error.$uid"
              >
                <div class="error-msg">{{ error.$message }}</div>
              </div>
            </div>
            <div
              class="md:col-span-9 xs:col-span-12"
              :class="{ error: v$.firstnameStaff.$errors.length }"
            >
              <label class="form-label text-theme-98">
                ชื่อ <span class="text-theme-5">*</span>
              </label>
              <input
                id="idcard-staff-input"
                type="text"
                class="form-control placeholder-theme-19"
                v-model="state.firstnameStaff"
                placeholder="กรุณากรอกชื่อ"
                data-test="idcard-staff-input"
              />
              <div
                class="input-errors"
                v-for="error of v$.firstnameStaff.$errors"
                :key="error.$uid"
              >
                <div class="error-msg">{{ error.$message }}</div>
              </div>
            </div>
            <div
              class="md:col-span-12 xs:col-span-12"
              :class="{ error: v$.lastnameStaff.$errors.length }"
            >
              <label class="form-label text-theme-98">
                นามสกุล <span class="text-theme-5">*</span>
              </label>
              <input
                id="idcard-staff-input"
                type="text"
                class="form-control placeholder-theme-19"
                placeholder="กรุณากรอกนามสกุล"
                data-test="idcard-staff-input"
                v-model="state.lastnameStaff"
              />
              <div
                class="input-errors"
                v-for="error of v$.lastnameStaff.$errors"
                :key="error.$uid"
              >
                <div class="error-msg">{{ error.$message }}</div>
              </div>
            </div>
            <div
              class="md:col-span-12 xs:col-span-12"
              :class="{ error: v$.telStaff.$errors.length }"
            >
              <label class="form-label text-theme-98">
                เบอร์โทรศัพท์ <span class="text-theme-5">*</span>
              </label>
              <input
                id="tel-staff-input"
                type="text"
                class="form-control placeholder-theme-19"
                maxlength="10"
                placeholder="กรุณากรอกเบอร์โทรศัพท์มือถือ"
                data-test="tel-staff-input"
                @input="onlyNumber"
                v-model="state.telStaff"
              />
              <div
                class="input-errors"
                v-for="error of v$.telStaff.$errors"
                :key="error.$uid"
              >
                <div class="error-msg">{{ error.$message }}</div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-right">
            <button
              type="button"
              data-dismiss="modal"
              class="
                btn btn-primary btn-outline-secondary
                w-15
                mr-1
                bg-theme-15
                font-medium
              "
              @click="closeModal('canceled')"
              data-test="cancel-add-volunteer-btn"
            >
              ยกเลิก
            </button>
            <button
              type="button"
              class="btn btn-primary w-15 font-medium"
              data-test="submit-staff-button"
              @click="submitForm"
            >
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Treeselect from "vue3-treeselect";
import useVuelidate from "@vuelidate/core";
import Swal from "sweetalert2";
import axios from "axios";
import { ref, reactive, watch, onMounted } from "vue";
import { required, helpers, minLength, maxLength } from "@vuelidate/validators";
import store from "@/store";

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  }
});

const props = defineProps({
  addVolunteerModal: { type: Boolean, default: false },
});
const emit = defineEmits(["modal-value"]);

const sumId = ref(true);
const title = reactive([
  { id: "นาย", label: "นาย" },
  { id: "นาง", label: "นาง" },
  { id: "นางสาว", label: "นางสาว" },
]);
const state = reactive({
  idcardStaff: "",
  titleStaffSelected: null,
  firstnameStaff: "",
  lastnameStaff: "",
  telStaff: "",
});
const rules = {
  titleStaffSelected: {
    required: helpers.withMessage("กรุณาเลือกคำนำหน้า", required),
  },
  firstnameStaff: { required: helpers.withMessage("กรุณากรอกชื่อ", required) },
  lastnameStaff: {
    required: helpers.withMessage("กรุณากรอกนามสกุล", required),
  },
  idcardStaff: {
    required: helpers.withMessage(
      "กรุณากรอกเลขบัตรประจำตัวประชาชน 13 หลัก",
      required
    ),
    minLength: helpers.withMessage(
      "กรุณากรอกเลขบัตรประชาชน 13 หลัก",
      minLength(13)
    ),
    maxLength: helpers.withMessage(
      "กรุณากรอกเลขบัตรประชาชน 13 หลัก",
      maxLength(13)
    ),
  },
  telStaff: {
    required: helpers.withMessage("กรุณากรอกเบอร์โทรศัพท์มือถือ", required),
    minLength: helpers.withMessage(
      "กรุณากรอกเบอร์โทรศัพท์มือถือ",
      minLength(10)
    ),
    maxLength: helpers.withMessage(
      "กรุณากรอกเบอร์โทรศัพท์มือถือ",
      maxLength(10)
    ),
  },
};
const v$ = useVuelidate(rules, state);

watch(
  () => props.addVolunteerModal,
  () => {
    if (props.addVolunteerModal) {
      cash("#static-backdrop-modal-preview-add-volunteer").modal("show");
    }
  }
);

const onlyNumber = () => {
  state.idcardStaff = state.idcardStaff.replace(/[^\d]/g, "");
  state.telStaff = state.telStaff.replace(/[^\d]/g, "");
};
const idState = () => {
  if (state.idcardStaff.length == 13) {
    var sum, i;
    if (state.idcardStaff.substring(0, 1) == 0) return false;
    for (i = 0, sum = 0; i < 12; i++)
      sum += parseFloat(state.idcardStaff.charAt(i)) * (13 - i);
    if ((11 - (sum % 11)) % 10 != parseFloat(state.idcardStaff.charAt(12)))
      return false;
    return true;
  } else if (state.idcardStaff.length > 1) {
    return false;
  } else {
    return null;
  }
};
const submitForm = async () => {
  const isFormCorrect = await v$.value.$validate();
  sumId.value = await idState();
  if (isFormCorrect && sumId.value) {
    swalCustom.fire({
      text:"ยืนยันบันทึกข้อมูล",
      icon:"info",
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
    }).then((result) => {
      if (result.isConfirmed) {
        sentApi();
      }
    });
  }
};
const sentApi = async () => {
  try {
    await axios
      .post(`${process.env.VUE_APP_BASE_API}volunteer/`, {
        doc: {
          uid: store.getters["userAuth/getSubordinateVt"],
          cm_uid: store.getters["userAuth/getUsername"],
          national_id: state.idcardStaff,
          title: state.titleStaffSelected,
          name: state.firstnameStaff,
          surname: state.lastnameStaff,
          tel_num: state.telStaff,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          swalCustom.fire({
            text:"สำเร็จ",
            icon: 'success',
            timer: 3000,
            confirmButtonText: "ปิด",
          }).then(function () {
            closeModal("saved");
          });
        } else {
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          });
        }
      });
  } catch (error) {
    console.log(error.message);
  }
};
const clearValue = () => {
  state.idcardStaff = "";
  state.titleStaffSelected = null;
  state.firstnameStaff = "";
  state.lastnameStaff = "";
  state.telStaff = "";
  sumId.value = true;
};
const closeModal = async (state) => {
  await clearValue();
  v$.value.$reset();
  emit("modal-value", state);
  cash("#static-backdrop-modal-preview-add-volunteer").modal("hide");
};

onMounted(() => {
  // cash("#static-backdrop-modal-preview-add-volunteer").modal("show");
});
watch(
  () => state.idcardStaff,
  () => {
    if (state.idcardStaff.length === 13) {
      sumId.value = idState();
    }
  }
);
</script>

<style>
/* .vue-treeselect__control {
  height: 38px;
} */
</style>